const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-grid-item",
};

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);
  if (event.detail.wishlist.length > 0) {
    wishTrue();
  } else {
    wishFalse();
  }
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist
  );

  console.log("reload swiper");
  reloadSwiper();
  if (event.detail.wishlist.length == 0) {
    document.querySelector(
      ".empty"
    ).innerHTML = `<p>Your wishlist is empty!</p>`;
  }

  if (event.detail.wishlist.length > 0) {
    wishTrue();
  } else {
    wishFalse();
  }
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist
  );
  if (event.detail.wishlist.length != 0) {
    wishTrue();
  } else {
    wishFalse();
  }
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard
      );
      return productCard.outerHTML;
      // reloadSwiper();
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener("click", () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

function wishTrue() {
  let wishHeart = document.querySelectorAll(".cart_dot");
  wishHeart.forEach(function (heart) {
    heart.classList.add("wishlist_true");
  });
}

function wishFalse() {
  let wishHeart2 = document.querySelectorAll(".cart_dot");
  wishHeart2.forEach(function (heart) {
    heart.classList.remove("wishlist_true");
  });
}

function reloadSwiper() {
  console.log("ok");
  class SizeListSwipers {
    constructor() {
      this.selectors = {
        sizeListSwiper: ".product-grid-item__size-list-swiper",
      };

      if (!document.querySelector(this.selectors.sizeListSwiper)) return;

      this.swiperOption = {
        slidesPerView: "auto",
      };

      this.initializeSwipers();
      // this.attachEventListeners();
    }

    attachEventListeners = () => {
      document.addEventListener("theme:product:reloaded", (e) =>
        this.initializeSwipers()
      );
      document.addEventListener("shopify-wishlist:updated", (event) => {
        console.log("wishlist updated");
        this.initializeSwipers();
      });

      document.addEventListener("shopify-wishlist:init-buttons", (event) => {
        console.log("init buttons");
        this.initializeSwipers();
      });

      document.addEventListener(
        "shopify-wishlist:init-product-grid",
        (event) => {
          console.log("wishlist initialized");
          this.initializeSwipers();
        }
      );
    };

    initializeSwipers = () => {
      const sizeListSwipers = document.querySelectorAll(
        this.selectors.sizeListSwiper
      );

      sizeListSwipers.forEach((swiper) => {
        const _navigation = {
          nextEl: `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-next`,
          prevEl: `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-prev`,
        };
        this.swiperOption["navigation"] = _navigation;
        new Swiper(
          `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"]`,
          this.swiperOption
        );
      });
    };
  }

  new SizeListSwipers();
  // new window.SizeListSwipers();
}

// Add an event listener to execute when the document is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Check if the local storage key "shopify-wishlist" is not null
  if (localStorage.getItem("shopify-wishlist") !== null) {
    // Call the function to handle the wishlist load
    wishTrue();
  }
});
